<template>
  <b-card no-body class="news-status-hist">
    <b-card-body>
      <app-timeline>
        <app-timeline-item
          v-for="(status, index) in newsData.event_status_hist"
          :key="index"
          :title="getTitle(status)"
          :subtitle="getSubtitle(status)"
          :time="formatDate(status.date, { dateStyle: 'short', timeStyle: 'medium' })"
          variant="success"
        />
      </app-timeline>
    </b-card-body>
  </b-card>
  <!-- <b-card-actions action-collapse :collapsed="true" title="Histórico de status">
    <b-card-body>
      <div
        v-for="(status, index) in newsData.event_status_hist"
        :key="index"
        class="d-flex justify-content-between align-items-center"
        style="padding-bottom: 10px; border-bottom: 1px solid #eee"
      >
        <div style="display: grid">
          <span><b>Status:</b> {{ status.name }}</span>
          <span><b>Usuário:</b> {{ status.user }}</span>
        </div>
        <div style="display: grid" v-if="status.dt_scheduled">
          <span
            ><b>Data Agendamento:</b>
            {{
              formatDate(status.dt_scheduled, {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
              })
            }}</span
          >
        </div>
        <div class="d-flex align-items-center">
          <small class="text-muted mr-75">{{
            formatDate(status.date, {
              day: "numeric",
              month: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
            })
          }}</small>
        </div> 
      </div> 
    </b-card-body>
  </b-card-actions> -->
</template>

<script>
import { BCard, BCardBody } from "bootstrap-vue";
// import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import { formatDate } from "@core/utils/filter";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    // BCardActions,
    BCard,
    BCardBody,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    newsData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getSubtitle(field) {
      if (field.author.name) {
        return field.author.name;
      }
      return field.author.email;
    },
    getFieldName(field) {
      if (field.i18n) {
        return this.$t('MAIN_MENU')[field.i18n];
      }
      return field.name;
    },
    getTitle(field) {
      if (field.dt_scheduled) {
        return `${this.getFieldName(field)} - ${formatDate(field.dt_scheduled, {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
            })}`
      }
      return this.getFieldName(field);
    }
  },  
  setup() {
    const getFormattedDate = (field) => {
      if (field) {
        return convertDatetimeHelper.convertStringToDateTime(field);
      }
      return "";
    };

    return {
      getFormattedDate,
      formatDate,
    };
  },
};
</script>

<style>
</style>
